import { xorBy } from "lodash";
import { useState, MouseEvent } from "react";
import { FilterOption } from "shared/components/Filter";
import { useAnchorEl } from "shared/hooks/useAnchorEl";

const SEARCH_FILTER_KEY = "label";

export const useDynamicFilter = ({ options }: { options: string[] }) => {
  const [selectedValues, setSelectedValues] = useState<FilterOption[]>([]);
  const { open, handleAnchorClose, handleAnchorOpen, anchorEl } = useAnchorEl();

  const fullOptionsList = options.map(
    (item) =>
      ({
        label: item,
        value: item.trim().toLocaleLowerCase(),
      }) as FilterOption,
  );

  const handleChangeValue = (
    _: MouseEvent<HTMLElement>,
    option: FilterOption,
  ) =>
    setSelectedValues((prevStatus) =>
      xorBy(prevStatus, [option], SEARCH_FILTER_KEY),
    );

  const onClearSelectedValues = () => setSelectedValues([]);

  return {
    filteredValues: selectedValues.map((item) => item[SEARCH_FILTER_KEY]) ?? [],
    setFilteredValues: setSelectedValues,
    filterData: {
      options: fullOptionsList,
      anchorEl,
      open,
      selectedValue: selectedValues,
      handleOpenMenu: handleAnchorOpen,
      handleChangeValue,
      handleClose: handleAnchorClose,
      onClearSelectedValues,
    },
  };
};
